import { render } from "./HeroiconsSolidArrowNarrowRight.vue?vue&type=template&id=bbae033c"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowNarrowRight.vue"]])

export default __exports__